const MODAL_ID = 'vjs-visual-discovery-how-it-works'
const STEPS_ID = 'vjs-visual-discovery-steps'
// Also hides the header steps. Renamed, it would reshow both to everyone.
const DISMISSED_KEY = 'visualDiscoveryHowItWorksDismissed'

// Storage can throw (private windows, blocked site data). Unreadable counts as
// not dismissed, so the explainer still shows; it just is not remembered.
function isDismissed () {
  try {
    return Boolean(window.localStorage.getItem(DISMISSED_KEY))
  } catch (_error) {
    return false
  }
}

function rememberDismissal () {
  try {
    window.localStorage.setItem(DISMISSED_KEY, Date.now().toString())
  } catch (_error) {}
}

// modals.js does the closing; this only records it, on the same two gestures.
function handleClick (event) {
  const isBackdrop = event.target === event.currentTarget
  if (isBackdrop || event.target.closest('.vjs-modal-close')) rememberDismissal()
}

function revealSteps () {
  document.getElementById(STEPS_ID)?.classList.remove('hidden')
}

function openModal () {
  const modal = document.getElementById(MODAL_ID)
  if (!modal) return

  modal.addEventListener('click', handleClick)
  modal.classList.add('show')
}

// Steps stay up for the rest of this page once the modal closes; hidden from the next load.
export default function initVisualDiscoveryHowItWorks () {
  if (isDismissed()) return

  revealSteps()
  openModal()
}
